import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IAgreement extends BaseEntity {
    dateTimeFrom: any;
    dateTimeTo: any;
    accountId: string;
    employeeId: string;
    employeeDisplayName: string;
    grossHourlyWageValue: number;
    calculationIndex: number;
    salaryScaleId: string;
    fee: number;
    ort: boolean;
}


export class AgreementService extends BaseService<IAgreement> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/AccountAgreements');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/agreements.service.ts